<!-- SubdivisionHistory.vue -->
<template>
  <div class="modal fade subdivision-history-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Subdivision History</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3">Loading subdivision history...</p>
          </div>

          <div v-else-if="noHistory" class="text-center p-5">
            <div class="alert alert-info">
              <i class="bx bx-info-circle font-size-24 me-2"></i>
              <p class="mb-0">No subdivision history found for this property.</p>
            </div>
          </div>

          <div v-else>
            <div class="row mb-4">
              <div class="col-12">
                <div class="card border">
                  <div class="card-header bg-light">
                    <h5 class="mb-0">Parent Property Information</h5>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <p><strong>LR Number:</strong> {{ parentProperty.LRNumber }}</p>
                        <p><strong>Original Size:</strong> {{ parentProperty.percelSize }} Ha</p>
                        <p><strong>Owner:</strong> {{ parentProperty.ownerNames }}</p>
                      </div>
                      <div class="col-md-6">
                        <p><strong>Subdivision Date:</strong> {{ formatDate(subdivisionInfo.subdivision_date) }}</p>
                        <p><strong>Reference:</strong> {{ subdivisionInfo.subdivision_reference }}</p>
                        <p><strong>Subdivided By:</strong> {{ subdivisionInfo.subdivided_by }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h5 class="mb-3">Resulting Properties</h5>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead class="table-light">
                    <tr>
                      <th>LR Number</th>
                      <th>Size (Ha)</th>
                      <th>Owner</th>
                      <th>Contact</th>
                      <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(property, index) in subdivisionPlots" :key="index">
                      <td>{{ property.new_lr_number }}</td>
                      <td>{{ property.plot_size }}</td>
                      <td>{{ property.owner_name }}</td>
                      <td>{{ maskPhoneNumber(property.owner_phone) }}</td>
                      <td>
                        <button
                            @click="viewPropertyDetails(property.new_lr_number)"
                            class="btn btn-sm btn-info"
                        >
                          <i class="bx bx-show-alt"></i> View
                        </button>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot class="table-light">
                    <tr>
                      <td colspan="1"><strong>Total</strong></td>
                      <td>
                        <strong>
                          {{ totalSize }} Ha
                        </strong>
                      </td>
                      <td colspan="3"></td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div v-if="secondarySubdivisions.length > 0" class="row mt-4">
              <div class="col-12">
                <h5 class="mb-3">Further Subdivisions</h5>
                <div class="alert alert-info">
                  <p>Some of the resulting properties have been further subdivided:</p>
                  <ul class="mb-0">
                    <li v-for="(prop, index) in secondarySubdivisions" :key="index">
                      <strong>{{ prop.LRNumber }}</strong> was subdivided into {{ prop.count }} plots on {{ formatDate(prop.date) }}
                      <button @click="loadSubdivisionDetails(prop.reference)" class="btn btn-sm btn-link">View Details</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn btn-secondary">Close</button>

          <button
              v-if="!noHistory"
              @click="printSubdivisionCertificate"
              class="btn btn-primary"
          >
            <i class="bx bx-printer me-1"></i> Print Certificate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {base, execute, landRate} from "@/api";
import moment from "moment";

export default {
  name: "SubdivisionHistory",
  props: {
    propertyId: {
      type: [String, Number],
      required: true
    },
    lrNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      noHistory: false,
      parentProperty: {},
      subdivisionInfo: {},
      subdivisionPlots: [],
      secondarySubdivisions: []
    };
  },
  computed: {
    totalSize() {
      return this.subdivisionPlots.reduce((total, plot) => {
        return total + parseFloat(plot.plot_size);
      }, 0).toFixed(2);
    }
  },
  watch: {
    propertyId: {
      immediate: true,
      handler() {
        this.loadSubdivisionHistory();
      }
    }
  },
  methods: {

    loadSubdivisionHistory() {
      this.loading = true;
      this.noHistory = false;

      // First check if this property is subdivided
      const formData = new FormData();
      formData.append("function", "getProperty");
      formData.append("id", this.propertyId);
      execute(formData, landRate)
          .then((result) => {

            console.log("API Response:", result.data.data.property);

            if (result.success) {
              this.parentProperty = result.data.data.property;



              if (this.parentProperty.status === 'Subdivided') {
                // Property has been subdivided, get subdivision details
                this.getSubdivisionDetails();
              } else if (this.parentProperty.parent_property_id) {
                // This is a result of subdivision, show its parent's subdivision
                this.getParentSubdivision();
              } else {
                // No subdivision history
                this.loading = false;
                this.noHistory = true;
              }
            } else {
              this.loading = false;
              this.noHistory = true;
            }
          })
          .catch(error => {
            console.error("Error:", error);
            this.loading = false;
            this.noHistory = true;
          });
    },

    getSubdivisionDetails() {
      const formData = new FormData();
      formData.append("function", "getSubdividedProperties");
      formData.append("parentLRNumber", this.lrNumber);
      execute(formData, landRate)
          .then((result) => {
            this.loading = false;

            console.log("Subdivided properties result:", result);

            if (result.success && result.data.properties && result.data.properties.length > 0) {
              // Get subdivision reference from first property
              const subdivisionReference = result.data.properties[0].subdivision_reference;

              // Get subdivision info
              this.getSubdivisionInfo(subdivisionReference);

              // Get subdivision plots
              this.getSubdivisionPlots(subdivisionReference);

              // Check for secondary subdivisions
              this.checkSecondarySubdivisions(result.data.properties);
            } else {
              this.noHistory = true;
            }
          })
          .catch(error => {
            console.error("Error:", error);
            this.loading = false;
            this.noHistory = true;
          });
    },

    getSubdivisionInfo(reference) {
      const formData = new FormData();
      formData.append("function", "getSubdivisionHistory");
      formData.append("subdivisionReference", reference);

      execute(formData, landRate)
          .then((result) => {
            if (result.success && result.data.subdivisionHistory.length > 0) {
              // Extract subdivision info from first record
              const historyData = result.data.subdivisionHistory[0];
              this.subdivisionInfo = {
                subdivision_reference: historyData.subdivision_reference,
                subdivision_date: historyData.subdivision_date,
                num_subplots: historyData.num_subplots,
                subdivided_by: historyData.subdivided_by
              };

              // Extract plot info
              this.subdivisionPlots = result.data.subdivisionHistory.map(item => ({
                new_lr_number: item.new_lr_number,
                plot_size: item.plot_size,
                owner_name: item.owner_name,
                owner_phone: item.owner_phone
              }));
            }
          })
          .catch(error => {
            console.error("Error:", error);
          });
    },

    getSubdivisionPlots(reference) {
      // This is handled in getSubdivisionInfo already
    },

    getParentSubdivision() {
      const formData = new FormData();
      formData.append("function", "getProperty");
      formData.append("id", this.parentProperty.parent_property_id);

      execute(formData, landRate)
          .then((result) => {
            console.log("API Response:", result.data.data.property);
            if (result.success) {

              const parentProperty = result.data.data.property;
              this.getSubdivisionInfo(this.parentProperty.subdivision_reference);
              this.parentProperty = parentProperty;
              this.loading = false;
            } else {
              this.loading = false;
              this.noHistory = true;
            }
          })
          .catch(error => {
            console.error("Error:", error);
            this.loading = false;
            this.noHistory = true;
          });
    },

    checkSecondarySubdivisions(properties) {
      // Find properties that have been further subdivided
      const subdivided = properties.filter(p => p.status === 'Subdivided');//Subdivided
      if (subdivided.length > 0) {
        // For each subdivided property, get the count of its subplots
        const promises = subdivided.map(p => {
          const formData = new FormData();
          formData.append("function", "getSubdividedProperties");
          formData.append("parentLRNumber", p.LRNumber);

          execute(formData, landRate)
              .then((result) => {
                if (result.success && result.data.properties) {
                  return {
                    LRNumber: p.LRNumber,
                    count: result.data.properties.length,
                    date: p.updatedDate || p.dateCreated,
                    reference: result.data.properties[0]?.subdivision_reference
                  };
                }
                return null;
              });
        });

        Promise.all(promises)
            .then(results => {
              this.secondarySubdivisions = results.filter(r => r !== null);
            });
      }
    },

    loadSubdivisionDetails(reference) {
      // Implement to load the details of a specific subdivision
      // This would typically involve closing this modal and opening a new one
      // with the details of the specified subdivision
      alert('Loading subdivision details for reference: ' + reference);
    },

    viewPropertyDetails(lrNumber) {
      // Redirect to property details or open property details modal
      const formData = new FormData();
      formData.append("function", "getProperty");
      formData.append("keyword", lrNumber);
      execute(formData, landRate)
          .then((result) => {
            if (result.success) {
              // This would typically involve closing this modal and opening the property details modal
              // or redirecting to the property details page
              alert('Viewing property details for: ' + lrNumber);
            }
          });
    },

    printSubdivisionCertificate() {
      // Generate and print a subdivision certificate
      localStorage['params'] = JSON.stringify({
        subdivisionReference: this.subdivisionInfo.subdivision_reference
      });
      const routeData = this.$router.resolve({name: 'subdivision-certificate'});
      window.open(routeData.href, '_blank');
    },

    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input; // Return as is if input is null, undefined, or not a string
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input; // Return as is if not a phone number or too short
    },

    closeModal() {
      const modal = document.querySelector('.subdivision-history-modal');
      if (modal) {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
    }
  }
};
</script>